import { buildEndpointUrls } from "./apiUrls";

export async function settingsRequest(path, { method = "GET", body, signal } = {}) {
  const isForm = typeof FormData !== "undefined" && body instanceof FormData;
  const token = localStorage.getItem("token") || localStorage.getItem("authToken") || sessionStorage.getItem("token") || sessionStorage.getItem("authToken") || "";
  const urls = buildEndpointUrls(process.env.REACT_APP_API_BASE || "", `/api/${path}`, `/${path}`);
  for (let index = 0; index < urls.length; index += 1) {
    const response = await fetch(urls[index], { method, signal, credentials: "include", headers: { Authorization: `Bearer ${token.replace(/^Bearer\s+/i, "")}`, ...(body !== undefined && !isForm ? { "Content-Type": "application/json" } : {}) }, body: isForm ? body : body !== undefined ? JSON.stringify(body) : undefined });
    if (response.status === 404 && index < urls.length - 1) continue;
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || "Settings are unavailable. Please try again.");
    return data;
  }
  throw new Error("Settings are unavailable. Please try again.");
}
